<script lang="ts">
    import { Dialog, Button } from "attractions";
    import { Writable, writable } from "svelte/store";
    import type { Puzzle } from "../types";
    import { clone, validate } from "../utils/puzzle";
    import PuzzleStepper from "./PuzzleStepper.svelte";

    export let puzzle: Puzzle;
    export let onClose: (puzzle: Puzzle) => void;

    let currentPuzzle: Writable<Puzzle>;
    let error: string = null;
    let showTooltip: boolean = false;

    $: {
        currentPuzzle = writable(clone(puzzle));
    }

    $: {
        error = validate($currentPuzzle);
    }
</script>

<Dialog title="Edit Puzzle" closeCallback={() => onClose(null)}>
    <div class="content-container">
        <PuzzleStepper puzzle={currentPuzzle} />

        <div
            on:mouseenter={() => (showTooltip = true)}
            on:mouseleave={() => (showTooltip = false)}
        >
            <Button
                disabled={error !== null}
                class="save-btn"
                on:click={() => onClose($currentPuzzle)}
            >
                Save
                {#if error !== null && showTooltip}
                    <div class="tooltip-content">
                        {error}
                    </div>
                {/if}
            </Button>
        </div>
    </div>
</Dialog>

<style lang="scss">
    @import "theme.scss";

    .content-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    :global(.save-btn) {
        position: relative;
    }

    .tooltip-content {
        position: absolute;
        bottom: 0px;
        transform: translate(-35%, -120%);
        left: 0px;
        z-index: 100;
        width: 200px;
        border-radius: 16px;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        padding: 0.5rem;
        box-shadow: 0px 0px 8px -1px black;
        background: $background;
        color: white;
    }
</style>
